import { Button, Icon, Text, VStack } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the primary button
 * 
 * @param {Object} props The props of the component
 * @returns The primary button
 */
const PrimaryButton = ({ icon, isSelected, title, transform, ...props }) => (
  <Button variant={isSelected ? "active" : "inactive"} {...props}>
    <VStack gap={0} paddingX={"2px"}>
      {icon && <Icon as={icon} boxSize={5} transform={transform} />}
      {title && <Text>{title}</Text>}
    </VStack>
  </Button>
);

export default React.memo(PrimaryButton);
